import { environment } from '../../environments/environment';

interface DataLayerObject {
  event: string;
  [key: string]: any;
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const pushToDataLayer = (dataLayer: DataLayerObject): void => {
  try {
    if (environment.IsBet3000) {
      if (window.dataLayer || window.dataLayer.length >= 0) {
        window.dataLayer.push(dataLayer);
      }
    }
  } catch (e) {
    console.log(e);
  }
};
